import { NgModule } from '@angular/core';
import { FormsModule as NgFormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormAutocompleteModule } from './form-autocomplete/form-autocomplete.module';
import { FormButtonModule } from './form-button/form-button.module';
import { FormControlValueMapperModule } from './form-control-value-mapper/form-control-value-mapper.module';
import { FormFieldModule } from './form-field/form-field.module';
import { FormFormModule } from './form-form/form-form.module';
import { FormInputModule } from './form-input/form-input.module';
import { FormRangeSliderModule } from './form-range-slider/form-range-slider.module';
import { FormToggleBoxModule } from './form-togglebox/form-toggle-box.module';
import { FormTooltipModule } from './form-tooltip/form-tooltip.module';

/**
 * Alle Module, die in "/forms/" liegen sollen auch exportiert werden. Das
 * Forms-Module bündelt diese. Sie sollen nicht direkt verwendet werden.
 */
const OWN_MODULES = [
    FormButtonModule,
    FormInputModule,
    FormRangeSliderModule,
    FormToggleBoxModule,
    FormTooltipModule,
    FormFieldModule,
    FormFormModule,
    FormControlValueMapperModule,
    FormAutocompleteModule
];

/**
 * Bündelt alle Unter-Module, die für die Darstellung und Verwendung von SPP-Forms benötigt
 * werden. Schließt Buttons, FormFields, FormInputs (Text, Select, Autocomplete) ein.
 * Exportiert außerdem FormsModule und ReactiveFormsModule aus @angular/forms.
 */
@NgModule({
    imports: [
        OWN_MODULES
    ],
    exports: [
        NgFormsModule,
        // Notwendig, damit wir <common-form-input formControlName=> schreiben können
        ReactiveFormsModule,

        OWN_MODULES
    ],
})
export class FormsModule {
}
